<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: Betway
 * @LastEditTime: 2026-07-21 11:44:22
-->
<template>
  <div>
    <mrc_ess_table
      v-if="$route.name == 'staffRelationConfig'"
      :headers="headers"
      pageName="addStaffRelationConfig"
      :paginationOptions="options"
      @turnPage="getlist"
      :hideAddBtn="!hasBtn('add-staff-relation-config')"
      :isLoading="loading"
      :slotKey="[
        'staff_uuid',
        'correlation_uuid',
        'cr_staff_uuid',
        'created_utc_datetime',
      ]"
      :items="desserts"
    >
      <template v-slot:btns>
        <mrc_ess_uploadBtn
          type="7"
          :hrefUrl="uploadUrl"
          class="ml-4"
          v-btnAuth="['import-staff-relation-config']"
          :label="$t('label_Batch_Import')"
        ></mrc_ess_uploadBtn>
      </template>

      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="
            background: white;
            margin: 0;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            padding: 0 16px;
          "
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template v-slot:item.staff_uuid="{ item }">
        <mrc_ess_staffListView
          :staffuuid="item.staff_uuid"
          itemValue="user_id"
          :allList="allList"
        ></mrc_ess_staffListView>
      </template>

      <template v-slot:item.cr_staff_uuid="{ item }">
        <mrc_ess_staffListView
          :staffuuid="item.cr_staff_uuid"
          itemValue="user_id"
          :allList="allList"
        ></mrc_ess_staffListView>
      </template>
      <template v-slot:item.updated_utc_datetime="{ item }">
        {{ item.updated_utc_datetime | changeDate("YYYY/MM/DD HH:mm") }}
      </template>
      <template v-slot:item.correlation_uuid="{ item }">
        {{ INT(correlation_uuid_obj[item.correlation_uuid]) }}
      </template>

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon
              v-btnAuth="[
                'view-staff-relation-config',
                'edit-staff-relation-config',
                'delete-staff-relation-config',
              ]"
            >
              mdi-dots-vertical
            </v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import {
  staff_relation_config_list,
  staff_relation_config_delete,
  get_staff_list,
} from "@/service/api/staffRelationConfig.js";
import { STAFF_RELATION_CONFIG_URL } from "@/utils/constant/index.js";
import { getStaffListForFilter } from "@/service/api/autoComplete.js";
import { getBusinessList } from "@/service/api/prompt.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      uploadUrl: "",
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      stepIndex: 1,
      dialog: false,
      disabled: true,
      list: {},
      options: {
        pagesize: 5, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,
      desserts: [],
      allList: [],
      correlation_uuid_obj: {},
    };
  },
  computed: {
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-staff-relation-config"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-staff-relation-config"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-staff-relation-config"),
          type: "del",
        },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("label_A_departing_employee"),
          align: "start",
          value: "staff_uuid",
          sortable: false,
        },
        {
          // 员工关系
          text: this.$t("label_staff_correlation"),
          value: "correlation_uuid",
          sortable: false,
          align: "start",
        },
        {
          // 被关联员工
          text: this.$t("label_correlation_staff"),
          value: "cr_staff_uuid",
          sortable: false,
          align: "start",
        },
        {
          text: this.$t("label_upload_time"),
          value: "updated_utc_datetime",
          sortable: false,
          align: "start",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
          width: "100",
        },
      ];
    },
    company_uuid() {
      //当前选中公司
      return this.$store.state.currentCompany;
    },
    staff_correlation() {
      return {
        prompt_name: "staff_correlation",
        org_level_uuid: this.company_uuid,
      };
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    await this.getBtnPermissionList();
  },
  watch: {
    $route(v) {
      if (v.name == "staffRelationConfig") {
        this.getlist();
      }
    },
  },
  async mounted() {
    this.uploadUrl = STAFF_RELATION_CONFIG_URL;
    this.loading = true;
    const res = await getBusinessList(this.staff_correlation);
    res.data.forEach((item) => {
      this.correlation_uuid_obj[item.value_field] = item.view_fields;
    });
    await this.getdropDownList();
    await this.getlist();
    this.loading = false;
  },
  beforeDestroy() {
    this.$ls.remove("staffList");
  },
  methods: {
    async getdropDownList() {
      const res = await getStaffListForFilter({
        org_level_uuid: this.$store.state.currentCompany,
      });
      if (res.code == 200) {
        this.allList = res.data;
      }
    },
    async getlist(obj) {
      this.loading = true;
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--;
      if (obj) {
        const { cpage, pagesize } = obj;
        this.options = { ...this.options, ...obj };
      }
      const res = await staff_relation_config_list({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      if (res.code == 200) {
        this.desserts = res.data;
        this.options.totalcount = res.totalcount;
        this.options.totalpage = res.totalpage;
        this.systemFieldMeta = res.systemFieldMeta;
        this.field_alias_name = res.field_alias_name;
        this.table_alias_name = res.table_alias_name;
      }
      this.loading = false;
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true); //行内进图标显示
      this.$store.commit("set_subPage_name", item.show_name);
      this.$store.commit("set_uuid", item.uuid); //
      this.$router.push({
        name: "detailStaffRelationConfig",
      });
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj);
          break;
        case "edit":
          this.$store.commit("set_subPage_name", obj.show_name);
          this.$store.commit("set_iconstatus", false); //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid); //
          this.$router.push({
            name: "detailStaffRelationConfig",
          });
          break;
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            staff_relation_config_delete({ uuid: obj.uuid }).then((res) => {
              if (res.code === "200") {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                });
                if (this.desserts.length == 1) this.options.cpage--;
                this.getlist();
              }
            });
          });
          break;
      }
    },
    success() {},
    cancel() {},
  },
};
</script>

<style scoped>
.cardtitle {
  position: relative;
}

.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}

.dowanTemplate {
  position: absolute;
  right: 180px;
  top: -50px;
}
</style>
